import { Resource } from "../resource";

export class DocumentResource<R extends Resource = Resource> {
    data: R = <R>new Resource();
}